"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLinePoint = exports.CollectionModelDrawableLinePointMutator = void 0;
var tslib_1 = require("tslib");
var vector_1 = require("../../../math/vector");
var drawable_1 = require("./drawable");
var CollectionModelDrawableLinePointMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLinePointMutator, _super);
    function CollectionModelDrawableLinePointMutator(drawable) {
        return _super.call(this, drawable) || this;
    }
    CollectionModelDrawableLinePointMutator.prototype.init = function (x, y) {
        _super.prototype.setPosition.call(this, x, y);
    };
    /** Lines can only be moved left/right */
    CollectionModelDrawableLinePointMutator.prototype.move = function (x, y) {
        _super.prototype.move.call(this, x, this.drawable.state.y);
    };
    return CollectionModelDrawableLinePointMutator;
}(drawable_1.CollectionModelDrawableMutator));
exports.CollectionModelDrawableLinePointMutator = CollectionModelDrawableLinePointMutator;
var CollectionModelDrawableLinePoint = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLinePoint, _super);
    function CollectionModelDrawableLinePoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelDrawableLinePoint.TAG;
        _this.Mutator = new CollectionModelDrawableLinePointMutator(_this);
        return _this;
    }
    CollectionModelDrawableLinePoint.state = function (id, parentId) {
        return {
            id: id,
            parentId: parentId,
            tag: 'line-point',
            x: 0,
            y: 0
        };
    };
    CollectionModelDrawableLinePoint.isLinePoint = function (t) {
        return t.tag === CollectionModelDrawableLinePoint.TAG;
    };
    Object.defineProperty(CollectionModelDrawableLinePoint.prototype, "parent", {
        get: function () {
            return this.drawableState.getDrawable(this.state.parentId);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLinePoint.prototype.getVector = function () {
        var stateValue = this.state;
        return new vector_1.Vector(stateValue.x, stateValue.y);
    };
    CollectionModelDrawableLinePoint.TAG = 'line-point';
    return CollectionModelDrawableLinePoint;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableLinePoint = CollectionModelDrawableLinePoint;
//# sourceMappingURL=line.point.drawable.js.map